.spacer {
  display: flex;
  margin-right: 0.5em;

  .content {
    display: inline-flex;
    flex-grow: 1;
  }
}
